import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from './components/routes/AppRoutes';
 
const App = () => (
  <Router>
    <AppContent />
  </Router>
);
 
const AppContent = () => (
  <div>
    <ToastContainer />
    <AppRoutes />
  </div>
);
 
export default App;
